import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, cambios_no_guardados } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import ModalService from '../../../ModalService/ModalService';
import FormTipoAcumulado from './FormTipoAcumulado';
import AlertForm from '../../../../../../Services/AlertForm';

const ModalEditTipoAcumulado = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, nombreModulo }) => {

    const [error, setError] = useState(null);

    const cerrarModal = () => {
        setOpenEdit(false);
        setError(null);
    }

    const actualizarTipoAcumulado = (info, acumuladoId) => {
        Axios.put( `${servicios_grupogack_catalogo}s/tipoacumulado/${acumuladoId}`, info, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    editar(res.data.dataResponse);
                    setOpenEdit(false);
                break;
                case 400:
                case 404:
                    setError(<AlertForm message={res.data.msg} />);
                    break;

                default:
                    errorTable(cambios_no_guardados);
                    break;

            }
        })
        .catch(error => errorTable(cambios_no_guardados));
    }

    return (
        <ModalService title="Actualizar Tipo de Acumulado" parentNode={nombreModulo}
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormTipoAcumulado
                        setError={setError}
                        error={error}
                        elementSelect={elementSelect}
                        actualizarTipoAcumulado={actualizarTipoAcumulado}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalEditTipoAcumulado;